<template>
<div class="pensiones">
  <md-progress-bar md-mode="indeterminate" v-if="loading"/>
  <div id="donutchart-business"></div>
</div>
</template>

<script>
export default {
  mounted(){
    google.charts.load('current', {'packages':['corechart']})
    google.charts.setOnLoadCallback(this.drawChart)
  },
  props: ["dataChart"],
  data() {
    return {
      loading: true
    }
  },
  created(){
    console.log(this.dataChart)
  },
  computed:{
    microData(){
      if(!this.dataChart.data.length) return 0
      return this.dataChart.data.filter(d => d.type=="micro")[0] ? this.dataChart.data.filter(d => d.type=="micro")[0].total : 0
    },
    littleData(){
      if(!this.dataChart.data.length) return 0
      return this.dataChart.data.filter(d => d.type=="little")[0] ? this.dataChart.data.filter(d => d.type=="little")[0].total : 0
    },
    middleMacroData(){
      if(!this.dataChart.data.length) return 0
      return this.dataChart.data.filter(d => d.type=="middle-macro")[0] ? this.dataChart.data.filter(d => d.type=="middle-macro")[0].total : 0
    }
  },
  methods: {
    drawChart(){
      console.log(this.dataChart)
      var data = google.visualization.arrayToDataTable([
        ['Tipo de Empresa','Cantidad'],
        [this.dataChart.legend["micro"],this.microData],
        [this.dataChart.legend["little"],this.littleData],
        [this.dataChart.legend["middle-macro"],this.middleMacroData],
      ])
      var options = {
        title: 'Tipo de Empresas',
        pieHole: 0.3,
        slices: {
          0: {color: '#acced4'},
          1: {color: '#97c2c9'},
          2: {color: '#799ba1'},
        }
      }
      var chart = new google.visualization.PieChart(document.getElementById('donutchart-business'))

      chart.draw(data, options)
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: '../assets/img/';

//2-VENDORS

//3-TOOLS
//functions
//background-image function
@function bimg($img){
  @return url($p-img+$img);
}
//mixins
@mixin mqwh($min-width,$max-height){
  @media (min-width: $min-width) and (max-height: $max-height){
    @content;
  }
}

@mixin mq($min-width){
  @media screen and (min-width: $min-width){
    @content;
  }
}

//8-TRUMPS
#donutchart-business{
  width: 360px;
  height: 200px;
  @include mq('700px'){
    width: 47rem;
    height: 19rem;
  }
  @include mq($md){
    width: 39rem;
  }
  @include mq('990px'){
    width: 47rem
  }
  @include mq($lg){
    width: calc(525px + 21rem)
  }
}

.pensiones{
  padding: 2rem 0;
  background-color: #fff;
  border-radius: .6rem;
}
</style>
